export const ar = {
  common: {
    save: "حفظ",
    cancel: "إلغاء",
    confirm: "تأكيد",
    close: "إغلاق",
    retry: "إعادة المحاولة",
    loading: "جارٍ التحميل…",
    yes: "نعم",
    no: "لا",
    back: "رجوع",
    edit: "تعديل",
    delete: "حذف",
    actions: "إجراءات",
    required: "هذا الحقل مطلوب",
    saved: "تم الحفظ",
  },
  auth: {
    title: "تسجيل الدخول",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    login: "دخول",
    logout: "تسجيل الخروج",
    failed: "تعذر تسجيل الدخول. تحقق من اسم المستخدم وكلمة المرور.",
    inactive: "هذا الحساب غير مفعّل. راجع المسؤول.",
  },
  shell: {
    fallback_name: "خريطة التغطية التسويقية",
    menu: "القائمة",
    admin: "لوحة الإدارة",
    install: "تثبيت التطبيق",
    installed: "التطبيق مثبّت",
    role: { admin: "مسؤول", employee: "موظف" },
    config_error: "إعدادات التطبيق ناقصة. راجع متغيرات البيئة.",
    crashed: "حدث خطأ غير متوقع في التطبيق.",
    reload: "إعادة تحميل التطبيق",
    offline: "لا يوجد اتصال: قد لا تكون الخريطة محدّثة، والحفظ متوقف",
    update_ready: "يتوفر إصدار جديد من التطبيق",
    update_now: "تحديث الآن",
  },
  install: {
    title: "ثبّت التطبيق على هاتفك",
    body: "افتح الخريطة مباشرة من الشاشة الرئيسية، بملء الشاشة ودون شريط المتصفح.",
    install: "تثبيت التطبيق",
    later: "لاحقًا",
    steps_title: "طريقة الإضافة إلى الشاشة الرئيسية:",
    steps: {
      ios: [
        "اضغط زر المشاركة في المتصفح (مربع يخرج منه سهم للأعلى).",
        "اختر «إضافة إلى الشاشة الرئيسية».",
        "اضغط «إضافة».",
      ],
      android: [
        "افتح قائمة المتصفح (⋮).",
        "اختر «تثبيت» أو «إضافة إلى الشاشة الرئيسية».",
        "أكّد الإضافة.",
      ],
      "macos-safari": ["من قائمة «ملف» في Safari اختر «إضافة إلى Dock».", "اضغط «إضافة»."],
    },
  },
  map: {
    unavailable: "الخريطة غير متاحة حاليًا",
    unavailable_hint: "تعذر تحميل خريطة الأساس. بيانات التطبيق لا تتأثر.",
    loading: "جارٍ تحميل الخريطة…",
    data_failed: "تعذر تحميل بيانات الخريطة.",
    locate: "موقعي",
    locate_denied: "لم يُسمح بالوصول إلى الموقع.",
    locate_failed: "تعذر تحديد الموقع.",
    layers: "الطبقات",
    search: "البحث",
    search_clear: "مسح البحث",
    search_close: "إغلاق البحث",
    legend: "الموظفون",
    legend_empty: "لا يوجد موظفون مفعّلون.",
    add_area: "إضافة منطقة",
  },
  drawing: {
    choose_shape: "اختر شكل المنطقة",
    polygon: "مضلع",
    rectangle: "مستطيل",
    circle: "دائرة",
    hint_polygon: "انقر لإضافة النقاط، ثم انقر النقطة الأولى لإغلاق الشكل.",
    hint_rectangle: "انقر على زاوية، ثم انقر على الزاوية المقابلة.",
    hint_circle: "انقر على المركز، ثم انقر على الحافة.",
    hint_edit: "اسحب النقاط لتعديل الشكل، أو اسحب نقطة الوسط لإضافة نقطة.",
    undo_point: "تراجع عن نقطة",
    confirm: "تأكيد",
    cancel: "إلغاء",
    name_label: "اسم المنطقة (اختياري)",
    saving: "جارٍ الحفظ…",
    saved: "تم حفظ المنطقة",
    save_failed: "تعذر حفظ المنطقة. الشكل محفوظ على الشاشة.",
    edit_saved: "تم تعديل الشكل",
    invalid_geometry: "الشكل غير صالح. تأكد من أن الخطوط لا تتقاطع.",
    too_many_vertices: "عدد النقاط كبير جدًا (الحد ٢٠٠).",
    area_too_small: "المنطقة صغيرة جدًا (الحد الأدنى ١٠٠ م²).",
    area_too_large: (maxKm2: number) => `المنطقة أكبر من الحد المسموح (${maxKm2} كم²).`,
    shape_not_enabled: "هذا الشكل غير متاح حاليًا.",
  },
  filters: {
    search_label: "بحث عن منطقة",
    search_placeholder: "اسم المنطقة أو اسم الموظف",
    search_empty: "لا توجد نتائج.",
    employees: "الموظف",
    all: "الكل",
    stale_only: "تحتاج زيارة",
    date: "التاريخ",
    presets: {
      all: "كل الأوقات",
      today: "اليوم",
      "7d": "آخر 7 أيام",
      "30d": "آخر 30 يومًا",
      custom: "فترة محددة",
    },
    from: "من",
    to: "إلى",
    clear: "مسح الفلاتر",
    counts_title: "التغطية",
    counts: {
      shown: "معروضة",
      completed: "مكتملة",
      completedToday: "مكتملة اليوم",
      inProgress: "قيد العمل",
      stale: "تحتاج زيارة",
    },
    active_hint: "فلاتر مفعّلة",
    former: "سابق",
  },
  location: {
    status: {
      sharing: "موقعك مُشارَك مع الفريق",
      requesting: "بانتظار إذن الموقع…",
      paused: "مشاركة الموقع متوقفة مؤقتًا",
      denied: "الموقع غير مُشارَك: لم يُسمح بالوصول إلى الموقع",
      unavailable: "الموقع غير مُشارَك: تعذر تحديد الموقع",
      error: "الموقع غير مُشارَك: انتهت مهلة تحديد الموقع",
      unsupported: "هذا المتصفح لا يدعم تحديد الموقع",
      offline: "الموقع غير مُشارَك: لا يوجد اتصال",
      disabled: "",
    },
    help: {
      denied:
        "اسمح للتطبيق بالوصول إلى الموقع من إعدادات المتصفح ثم أعد فتح الخريطة. باقي الميزات تعمل بدونه.",
      unavailable: "تأكد من تشغيل الموقع (GPS) في الهاتف.",
      error: "سيُعاد المحاولة تلقائيًا.",
    },
    last_sent: (t: string) => `آخر إرسال ${t}`,
    teammate_title: "موقع زميل",
    last_seen: "آخر ظهور",
    stale_note: "لم يُحدَّث موقعه منذ مدة؛ قد يكون التطبيق مغلقًا أو الشاشة مقفلة.",
    accuracy: (m: number) => `دقة تقريبية ${Math.round(m)} م`,
    show_layer: "إظهار مواقع الزملاء",
  },
  comments: {
    add: "إضافة تعليق",
    add_here: "إضافة تعليق هنا",
    new_title: "تعليق جديد",
    on_area: (name: string) => `على المنطقة: ${name}`,
    free_point: "على نقطة في الخريطة",
    placeholder: "اكتب ملاحظتك…",
    counter: (used: number, max: number) => `${used} / ${max}`,
    send: "نشر التعليق",
    sending: "جارٍ النشر…",
    posted: "تم نشر التعليق",
    failed: "تعذر نشر التعليق. النص محفوظ، حاول مرة أخرى.",
    card_title: "تعليق",
    open_area: "عرض المنطقة",
    delete_confirm_title: "حذف التعليق؟",
    delete_confirm_body: "سيختفي التعليق من الخريطة لدى الجميع.",
    deleted: "تم حذف التعليق",
    area_list: "التعليقات",
    area_list_empty: "لا توجد تعليقات على هذه المنطقة.",
    show_layer: "إظهار التعليقات",
    comment_empty: "اكتب نص التعليق أولًا.",
    comment_too_long: (max: number) => `التعليق أطول من الحد المسموح (${max} حرفًا).`,
  },
  areas: {
    status: { in_progress: "قيد العمل", completed: "مكتملة" },
    untitled: "منطقة بلا اسم",
    created_by: "أنشأها",
    completed_by: "أكملها",
    last_updated: "آخر تحديث",
    visits: "الزيارات",
    visits_empty: "لا توجد زيارات بعد.",
    open_in_maps: "فتح في خرائط Google",
    complete: "إكمال المنطقة",
    complete_confirm_title: "إكمال المنطقة؟",
    complete_confirm_body: "ستُلوَّن المنطقة بلونك وتُسجَّل كزيارة باسمك.",
    completed_toast: "تم إكمال المنطقة",
    undo: "تراجع عن الإكمال",
    undo_until: (time: string) => `يمكن التراجع حتى ${time}`,
    undone_toast: "تم التراجع عن الإكمال",
    edit_shape: "تعديل الشكل",
    delete_confirm_title: "حذف المنطقة؟",
    delete_confirm_body: "ستختفي المنطقة من الخريطة لدى الجميع.",
    deleted_toast: "تم حذف المنطقة",
    picker_title: "عدة مناطق هنا",
    picker_hint: "اختر المنطقة المطلوبة:",
    overlap_title: "تنبيه: منطقة مغطاة سابقًا",
    overlap_body: "تتداخل المنطقة الجديدة بشكل كبير مع:",
    overlap_line: (name: string, date: string, percent: number) =>
      `غطّاها ${name} بتاريخ ${date} (${percent}٪ تداخل)`,
    overlap_keep: "الإبقاء على المنطقة الجديدة",
    overlap_delete: "حذف المنطقة الجديدة",
    already_done: "تم تنفيذ هذا الإجراء مسبقًا.",
    undo_window_passed: "انتهت مهلة التراجع.",
    not_allowed: "لا يمكنك تنفيذ هذا الإجراء على هذه المنطقة.",
    stale_title: "منطقة تحتاج زيارة",
    stale_body: (relative: string) => `لم تُزر هذه المنطقة منذ مدة. آخر زيارة ${relative}`,
    stale_last: (name: string, date: string) => `بواسطة ${name} بتاريخ ${date}`,
    revisit: "تسجيل زيارة جديدة",
    revisit_confirm_title: "تسجيل زيارة جديدة؟",
    revisit_confirm_body: "ستصبح المنطقة بلونك وتُضاف زيارتك إلى سجل الزيارات.",
    revisited_toast: "تم تسجيل الزيارة",
    overlap_revisit: "تسجيل زيارة لهذه المنطقة بدل إنشاء منطقة جديدة",
    overlap_stale_badge: "تحتاج زيارة",
    not_stale: "هذه المنطقة ليست بحاجة إلى زيارة بعد.",
    feature_disabled: "هذه الميزة غير مفعّلة حاليًا.",
  },
  admin: {
    title: "لوحة الإدارة",
    tabs: { employees: "الموظفون", settings: "الإعدادات" },
    employees: {
      add: "إضافة موظف",
      edit: "تعديل الموظف",
      list_empty: "لا يوجد موظفون بعد.",
      name: "الاسم",
      username: "اسم المستخدم",
      username_hint: "٣ إلى ٣٠ حرفًا: أحرف إنجليزية صغيرة، أرقام، . _ -",
      password: "كلمة المرور",
      password_hint: "٨ أحرف على الأقل",
      new_password: "كلمة المرور الجديدة",
      color: "اللون على الخريطة",
      custom_color: "لون مخصص",
      role: "الدور",
      active: "مفعّل",
      inactive: "غير مفعّل",
      last_seen: "آخر ظهور",
      never_seen: "لم يظهر بعد",
      reset_password: "إعادة تعيين كلمة المرور",
      deactivate: "تعطيل",
      reactivate: "إعادة التفعيل",
      delete_confirm_title: "حذف الحساب نهائيًا؟",
      delete_confirm_body:
        "هذا الحساب لا يملك أي سجل على الخريطة وسيُحذف نهائيًا. لا يمكن التراجع.",
      deactivate_confirm_title: "تعطيل الحساب؟",
      deactivate_confirm_body:
        "لن يتمكن الموظف من تسجيل الدخول وسيختفي من الخريطة الحية. تبقى مناطقه وتعليقاته باسمه ولونه.",
      reactivate_title: "إعادة تفعيل الحساب",
      reactivate_color_conflict:
        "لون هذا الموظف السابق يستخدمه الآن موظف مفعّل. اختر لونًا جديدًا.",
      has_history: "لهذا الموظف سجل على الخريطة؛ يمكن تعطيله فقط.",
      color_in_use: "هذا اللون يستخدمه موظف مفعّل حاليًا.",
      color_former: (owner: string) => `كان لونًا لـ ${owner}`,
      color_reuse_title: "تأكيد إعادة استخدام اللون",
      color_reuse_body: (owner: string) =>
        `هذا اللون استخدمه ${owner} سابقًا. مناطقه وتعليقاته القديمة ستبدو كأنها للموظف الجديد. هل تريد المتابعة؟`,
      self_notice: "لا يمكنك تعطيل حسابك أو حذفه أو تغيير دورك.",
      created: "تم إنشاء الحساب. يمكن للموظف تسجيل الدخول الآن.",
    },
    settings: {
      groups: {
        general: "عام",
        map: "الخريطة",
        coverage: "التغطية",
        drawing: "الرسم",
        comments: "التعليقات",
        location: "الموقع",
      },
      fields: {
        app_name: "اسم التطبيق",
        map_start_lat: "خط عرض نقطة البداية",
        map_start_lng: "خط طول نقطة البداية",
        map_start_zoom: "مستوى التكبير الابتدائي",
        completed_fill_opacity: "شفافية تعبئة المناطق المكتملة",
        undo_window_minutes: "مهلة التراجع عن الإكمال (دقائق)",
        overlap_warn_percent: "حد التنبيه عند التداخل (٪)",
        max_area_km2: "الحد الأقصى لمساحة المنطقة (كم²)",
        enabled_shapes: "الأشكال المتاحة للرسم",
        stale_marking_enabled: "تمييز المناطق التي تحتاج زيارة",
        stale_after_days: "مدة اعتبار المنطقة بحاجة لزيارة (أيام)",
        stale_fill_opacity: "شفافية تعبئة المناطق التي تحتاج زيارة",
        revisit_enabled: "السماح بتسجيل زيارة جديدة",
        in_progress_expiry_hours: "حذف المناطق قيد العمل المتروكة بعد (ساعات)",
        comments_enabled: "تفعيل التعليقات",
        comment_max_length: "الحد الأقصى لطول التعليق (حرف)",
        location_sharing_enabled: "مشاركة مواقع الموظفين",
        location_stale_minutes: "تحويل علامة الزميل إلى الرمادي بعد (دقائق)",
      },
      shapes_min_one: "يجب إتاحة شكل واحد على الأقل.",
      use_current_view: "استخدام عرض الخريطة الحالي",
      default: "الافتراضي",
      range: "النطاق",
      restore_default: "استعادة الافتراضي",
      out_of_range: "القيمة خارج النطاق المسموح",
    },
  },
  errors: {
    forbidden: "ليست لديك صلاحية لهذا الإجراء.",
    network_error: "تعذر الاتصال بالخادم.",
    server_error: "حدث خطأ غير متوقع.",
    not_found: "العنصر غير موجود.",
    invalid_name: "الاسم غير صالح.",
    invalid_username: "اسم المستخدم غير صالح.",
    username_taken: "اسم المستخدم مستخدم بالفعل.",
    weak_password: "كلمة المرور قصيرة (٨ أحرف على الأقل).",
    invalid_color: "اللون غير صالح.",
    invalid_role: "الدور غير صالح.",
    color_in_use: "هذا اللون يستخدمه موظف مفعّل حاليًا.",
    color_previously_used: "هذا اللون استُخدم سابقًا ويحتاج تأكيدًا.",
    last_active_admin: "لا يمكن إزالة آخر مسؤول مفعّل.",
    cannot_modify_self: "لا يمكنك تطبيق هذا الإجراء على حسابك.",
    has_history: "لهذا الموظف سجل على الخريطة؛ يمكن تعطيله فقط.",
    auth_create_failed: "تعذر إنشاء الحساب.",
    auth_update_failed: "تعذر تحديث الحساب.",
    auth_delete_failed: "تعذر حذف الحساب.",
    db_error: "تعذر حفظ البيانات.",
    invalid_geometry: "الشكل غير صالح. تأكد من أن الخطوط لا تتقاطع.",
    too_many_vertices: "عدد النقاط كبير جدًا (الحد ٢٠٠).",
    area_too_small: "المنطقة صغيرة جدًا (الحد الأدنى ١٠٠ م²).",
    area_too_large: "المنطقة أكبر من الحد المسموح.",
    shape_not_enabled: "هذا الشكل غير متاح حاليًا.",
    not_allowed: "لا يمكنك تنفيذ هذا الإجراء على هذه المنطقة.",
    undo_window_passed: "انتهت مهلة التراجع.",
    not_stale: "هذه المنطقة ليست بحاجة إلى زيارة بعد.",
    feature_disabled: "هذه الميزة غير مفعّلة حاليًا.",
    comment_empty: "اكتب نص التعليق أولًا.",
    comment_too_long: "التعليق أطول من الحد المسموح.",
    invalid_location: "الموقع غير صالح.",
    offline: "لا يوجد اتصال بالإنترنت. لم يُحفظ شيء؛ أعد المحاولة عند عودة الاتصال.",
  } as Record<string, string>,
};

export function errorText(code: string): string {
  return ar.errors[code] ?? ar.errors.server_error ?? code;
}
